const reviews = [
    {
        name: "Ajisha",
        stars: 5,
        text: "Very impressed with the quality of medical equipment from Stockport Solutions. Everything was delivered on time and works flawlessly.",
    },
    {
        name: "Aswin",
        stars: 5,
        text: "The medical equipment from Stockport Solutions is excellent. Delivery was smooth, and everything works perfectly.",
    },
    {
        name: "Sophia Martinez ",
        stars: 5,
        text: "Very satisfied with the quality and reliability of the equipment. Customer service was helpful and responsive.",
    },
    {
        name: "Liam Thompson ",
        stars: 5,
        text: "Equipment arrived on time and in good condition. Overall, a dependable supplier.",
    },
    {
        name: "Niyana gosh ",
        stars: 5,
        text: "Highly recommend Stockport Solutions. The products are durable and meet all our requirements.",
    },
    {
        name: "Noah Wilson  ",
        stars: 5,
        text: "Good experience overall. The equipment is easy to set up and functions well.",
    },
    {
        name: "Olivia Brown ",
        stars: 5,
        text: "Excellent quality and prompt service. Would definitely purchase from them again.",
    },
    {
        name: "Ethan Taylor ",
        stars: 5,
        text: "Reliable supplier with high-quality medical equipment. Delivery and setup were smooth.",
    },
    {
        name: "Ava White ",
        stars: 5,
        text: "Products arrived quickly and in excellent condition. Very happy with the purchase.",
    },
    {
        name: "Mason Lee  ",
        stars: 5,
        text: "Good range of equipment and responsive support. Everything works as expected.",
    },
    {
        name: "Isabella Harris ",
        stars: 5,
        text: "Very professional and trustworthy supplier. The medical equipment is top-notch.",
    },
];

export default reviews;
